module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-04.a10e913e.png";